{
  "colorSwatchPicker": "Amostras de cores",
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Selecione um item",
  "tableResizer": "Redimensionador"
}
